import { api } from "@/api"

type ChangeSelfMerchantGroupAdminPasswordBody = {
  currentPassword?: string
  password: string
}

export const changeMerchantGroupAdminPassword = async (
  params: SetChangeResetPasswordFormOutput
) => {
  const body: ChangeSelfMerchantGroupAdminPasswordBody = {
    password: params.password,
    ...(params.currentPassword
      ? { current_password: params.currentPassword }
      : {}),
  }

  await api.post(
    "/merchant-group/merchant-group-admins/self/change-password/",
    {
      body,
      isMerchantGroup: true,
    }
  )
}
